import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiUri, API_URI } from "src/app/API_URI";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  private apiUri: ApiUri;

  constructor(public http: HttpClient, @Inject(API_URI) apiUri: ApiUri) {
    this.apiUri = apiUri;
  }
  getNotification(SSN?: any): Observable<any> {
    let ssn = "";
    if (SSN) {
      ssn = SSN;
    }
    return this.http.get(`${environment.apiUrl + this.apiUri.notification.GET}` + ssn);
  }
}
